import { AbstractControl, ValidatorFn } from '@angular/forms';
import isUrl from 'is-url';

export const urlValidator: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
  const { value } = control;
  const isURL = isUrl(value) && value?.startsWith('http');
  return isURL ? null : { url: { value: value } };
};
